import stringHash from "string-hash";
import uniq from "lodash/uniq";
import isEmpty from "lodash/isEmpty";
import { ACTION_TYPES, ASSET_TYPES, XR_MODES, AR_PLATFORM } from "../constants";
import { defaultSKUConfig } from "./EngineUtils";

const mod = () => {
  const skuConfigs = {};

  const addAsset = (skuId, url, type) => {
    const hashed = stringHash(url);

    // eslint-disable-next-line no-param-reassign
    skuConfigs[skuId].assets[hashed] = { type, url };
    console.log("hashed", url, hashed, skuConfigs[skuId].assets);
    return hashed;
  };
  const parseAndUpdateButtonTriggers = (skuId, action = []) => {
    console.log("parseAndUpdateButtonTriggers", skuId, action);
    action?.forEach((trigger) => {
      if (trigger.type === ACTION_TYPES.MATERIALS) {
        Object.keys(trigger.config).forEach((materialName) => {
          Object.entries(trigger.config[materialName]).forEach(
            ([atttributeName, attributeValue]) => {
              console.log(
                "parseAndUpdateButtonTriggers inside",
                atttributeName,
                attributeValue
              );
              if (atttributeName.toLowerCase().includes("map")) {
                if (String(attributeValue).startsWith("http"))
                  trigger.config[materialName][atttributeName] = addAsset(
                    skuId,
                    attributeValue,
                    ASSET_TYPES.TEXTURE
                  );
              }
            }
          );
        });
      }
    });
  };
  const getUsedTextures = (skuConfig) => {
    const usedAssets = [];
    const modes = [XR_MODES.XR, XR_MODES.AR];
    const modeList = {
      [XR_MODES.XR]: [AR_PLATFORM.THREEJS],
      [XR_MODES.AR]: [AR_PLATFORM.EIGHTHWALL, AR_PLATFORM.WEBXR],
    };
    if (skuConfig?.positionTexture) usedAssets.push(skuConfig?.positionTexture);
    if (isEmpty(skuConfig.uiConfig)) return usedAssets;
    if (isEmpty(skuConfig.uiConfig)) return usedAssets;

    const onloadConfig = { ...skuConfig.uiConfig.onLoad };
    if (!isEmpty(onloadConfig)) {
      modes.forEach((currentMode) => {
        modeList[currentMode]?.forEach((type) => {
          if (onloadConfig[currentMode] && onloadConfig[currentMode][type]) {
            onloadConfig[currentMode][type].forEach((buttonConfig) => {
              if (buttonConfig && buttonConfig.type === "materials") {
                Object.entries(buttonConfig.config).forEach(
                  ([, materialData]) => {
                    const keys = Object.values(materialData);
                    usedAssets.push(...keys);
                  }
                );
              }
            });
          }
        });
      });
    }

    if (skuConfig?.uiConfig?.menu?.length > 0) {
      skuConfig.uiConfig.menu.forEach((menuItem) => {
        const actionList = [];
        if (menuItem?.onClick?.length > 0) {
          actionList.push(...menuItem.onClick);
        }
        if (menuItem?.onUnClick?.length > 0) {
          actionList.push(...menuItem.onUnClick);
        }
        if (menuItem?.menu.length > 0) {
          menuItem.menu.forEach((colorAction) => {
            if (colorAction?.onClick?.length > 0) {
              actionList.push(...colorAction.onClick);
            }
            if (colorAction?.onUnClick?.length > 0) {
              actionList.push(...colorAction.onUnClick);
            }
          });
        }

        actionList.forEach((action) => {
          if (action && action.type === ACTION_TYPES.MATERIALS) {
            Object.entries(action.config).forEach(([, materialData]) => {
              const keys = Object.values(materialData);
              usedAssets.push(...keys);
            });
          }
        });
      });
    }
    return uniq(usedAssets.map((n) => String(n)));
  };
  return {
    setConfig: (skuId, config) => {
      skuConfigs[skuId] = config;
      console.log("setting config", skuId, config);
    },
    getSKUConfig: (skuId) => {
      return skuConfigs[skuId];
    },

    getParentLevelButtons: (skuId) => {
      const skuConfig = skuConfigs[skuId];
      return skuConfig.uiConfig.menu.map((e) => e.name);
    },
    addAsset: (skuId, assetkey, assetObject) => {
      const skuConfig = skuConfigs[skuId];
      skuConfig.assets[assetkey] = assetObject;
    },
    setDefaultOnLoadButton: (skuId, value) => {
      const skuConfig = skuConfigs[skuId];
      skuConfig.uiConfig.default = value;
    },
    addButton: (skuId, config, heirarchy) => {
      const skuConfig = skuConfigs[skuId];
      if (!("uiConfig" in skuConfig))
        skuConfig.uiConfig = { name: "firstLayer", menu: [] };
      if (!skuConfig.uiConfig.menu) {
        skuConfig.uiConfig.menu = [];
      }
      let { menu } = skuConfig.uiConfig;
      console.log("add button menu", menu);
      for (let i = 0; i < heirarchy.length; i += 1) {
        const subConfig = menu.find((e) => e.name === heirarchy[i]);
        menu = subConfig.menu;
      }
      console.log("add button final menu", menu);
      const index = menu.findIndex(
        (oldConfig) => oldConfig.name === config.name
      );
      if (index === -1) {
        menu.push(config);
      } else {
        menu[index] = { ...menu[index], ...config };
        menu[index].enabled = true;
      }
    },
    removeButton: (skuId, buttonName, heirarchy) => {
      const skuConfig = skuConfigs[skuId];
      let { menu } = skuConfig.uiConfig;

      if (heirarchy.length === 0) {
        menu = menu.filter((config) => config.name !== buttonName);
      } else {
        heirarchy.forEach((item) => {
          menu = menu.map((menuItem) => {
            const currentMenuItem = menuItem;
            if (currentMenuItem.name === item) {
              currentMenuItem.menu = currentMenuItem?.menu.filter(
                (config) => config.name !== buttonName
              );
            }
            return currentMenuItem;
          });
        });
      }
      skuConfigs[skuId].uiConfig.menu = menu;
      console.log("remove button menu", buttonName, heirarchy, menu);
    },
    updateDefaultButton: (skuId, buttonName, heirarchy) => {
      const skuConfig = skuConfigs[skuId];
      let { menu } = skuConfig.uiConfig;

      for (let i = 0; i < heirarchy.length; i += 1) {
        const subConfig = menu.find((e) => e.name === heirarchy[i]);
        menu = subConfig.menu;
      }
      // eslint-disable-next-line no-unused-vars
      const buttonConfig = menu.map((menuItem) => {
        if (menuItem.name === buttonName) {
          menuItem.default = 1;
        } else {
          menuItem.default = 0;
        }
        return menuItem;
      });
      console.log("update default button", buttonName, heirarchy, menu);
    },
    addButtonActions: (skuId, buttonConfig, heirarchy) => {
      const skuConfig = skuConfigs[skuId];
      let config = skuConfig.uiConfig;
      for (let i = 0; i < heirarchy.length; i += 1) {
        if (!config) break;
        config = config.menu.find((e) => e.name === heirarchy[i]);
      }
      if (config) {
        if (buttonConfig.onClick) config.onClick = buttonConfig.onClick;
        if (buttonConfig.onUnClick) config.onUnClick = buttonConfig.onUnClick;
        if (buttonConfig.correlation) {
          config.correlation = buttonConfig.correlation;
        } else {
          config.correlation = null;
        }
      }
      console.log(
        "buttonConfig till here",
        skuConfigs[skuId],
        config,
        buttonConfig
      );
      // parse config and attach assets
      if (heirarchy.length > 0) {
        parseAndUpdateButtonTriggers(skuId, config.onClick);
        parseAndUpdateButtonTriggers(skuId, config.onUnClick);
      }
      if (config.onLoad) {
        console.log(
          "config.onLoad.xr.VR_PLATFORM_THREEJS",
          config.onLoad.xr.VR_PLATFORM_THREEJS
        );
        parseAndUpdateButtonTriggers(
          skuId,
          config.onLoad.xr.VR_PLATFORM_THREEJS
        );
        parseAndUpdateButtonTriggers(
          skuId,
          config.onLoad.ar.AR_PLATFORM_8thwall
        );
        parseAndUpdateButtonTriggers(skuId, config.onLoad.ar.AR_PLATFORM_Webxr);
      }

      console.log("buttonConfig post update", skuConfigs[skuId], config);
    },
    generateDefaultSKUConfig: (config, latestGLB) => {
      const { producedAssets } = config;
      const hashedAssets = {};
      producedAssets.forEach((asset) => {
        const hashed = stringHash(asset.url);
        if (asset.type === "GLB" || asset.type === "COMPRESSED_GLB") {
          hashedAssets[hashed] = { type: ASSET_TYPES.GLTF, url: asset.url };
        } else {
          hashedAssets[hashed] = { type: asset.type, url: asset.url };
        }
      });
      const compressedGLBHash = Object.keys(hashedAssets).find((hash) => {
        if (
          hashedAssets[hash].type === ASSET_TYPES.GLTF &&
          latestGLB.url === hashedAssets[hash].url
        )
          return hash;
        return "";
      });
      defaultSKUConfig.models.path = String(compressedGLBHash);
      defaultSKUConfig.assets = { ...defaultSKUConfig.assets, ...hashedAssets };
      return {
        ...defaultSKUConfig,
        ...config,
      };
    },
    cleanAssetData: (skuConfig) => {
      const assetObject = {};
      const requiredTextures = getUsedTextures(skuConfig);
      Object.entries(skuConfig.assets).forEach(([assetHash, assetData]) => {
        if (
          assetData.type === ASSET_TYPES.GLTF &&
          String(assetHash) === String(skuConfig.models.path)
        ) {
          assetObject[assetHash] = skuConfig.assets[assetHash];
        } else if (assetData.type === ASSET_TYPES.TEXTURE) {
          if (requiredTextures.includes(String(assetHash))) {
            assetObject[assetHash] = assetData;
          }
        } else if (
          assetData.type !== ASSET_TYPES.GLTF &&
          assetData.type !== ASSET_TYPES.TEXTURE
        ) {
          assetObject[assetHash] = skuConfig.assets[assetHash];
        }
      });
      skuConfig.assets = assetObject;
      return skuConfig;
    },
  };
};

const ConfigBuilder = mod();
export default ConfigBuilder;
